import { LoadingContainer } from "./style";

interface LoadingStateProps {
  loadComment?: string;
}
const LoadingState = ({ loadComment }: LoadingStateProps) => {
  return (
    <>
      <LoadingContainer>
        <i>
          <span></span>
          <span></span>
          <span></span>
        </i>
        <em>{loadComment}</em>
      </LoadingContainer>
    </>
  );
};
export default LoadingState;
